
export const BASE_URL = process.env.REACT_APP_API_URL;

export const END_POINTS = {
  roles: "roles",
  login: "login",
  changePassword: "changePass",
  unlock: "unlock",
  resetPassword: "resetPass",
  getFile: "getFile3",
};
